module.exports = __webpack_public_path__ + "static/img/bighaibao1.16fbaff.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/bighaibao1.png
// module id = S5NN
// module chunks = 0